import React, { Component } from "react";
import BreadCrumbs from "../bcase/BreadCrumbs";
import Menu from "../bcase/Menu";
import Content from "../bcase/Content";
import { isNil, some, pick } from "lodash";
import { fetchAllStaticData } from "../../api/StaticDataService";
import { Loader } from "react-loaders";
import { goBack } from "api/Location";

const dashboardStyle = {
  width: "100%"
};

const columnsStyle = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};

const menuStyle = {
  paddingRight: 0
};

class BusinessCase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.initialState,
      currentRound: "",
      roundInUrl: props.roundInUrl,
      rounds: []
    };
  }

  get initialState() {
    return {
      initialDemand: null,
      salesClients: null,
      constants: null,
      primeRates: null,
      demandGrowthRate: null,
      features: null,
      machines: null,
      debtClients: null,
      ratings: null,
      comparableCompanies: null,
      // Scalars pre-computed by the business-case-scoped endpoint,
      // replacing the previous FE-side reductions over
      // customerPreferences and customerDemand (both dropped from the
      // scoped payload to save ~90 KB per open).
      bcaseRevenueEstimate: null,
      bcasePriceFloor: null,
      bcasePriceCeiling: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentRound !== this.state.currentRound ||
      nextProps.roundInUrl !== this.state.roundInUrl ||
      nextProps.rounds !== this.state.rounds
    ) {
      this.setState(
        {
          currentRound: nextProps.currentRound,
          roundInUrl: nextProps.roundInUrl,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  componentDidMount() {
    this.setState(
      {
        currentRound: this.props.currentRound,
        roundInUrl: this.props.roundInUrl,
        rounds: this.props.rounds
      },
      () => {
        this.fetchData();
      }
    );
  }

  getRound = () => {
    const { currentRound, roundInUrl } = this.state;

    return roundInUrl !== null ? roundInUrl : currentRound;
  };

  fetchData = () => {
    const { rounds, roundInUrl } = this.state;

    if ((!rounds || rounds.length === 0) && !roundInUrl) {
      return;
    }

    const round = this.getRound();
    // Scoped endpoint returns initial_demand and constants as objects
    // (not single-element arrays like the un-scoped payload), so no
    // [0] indirection here. customer_preferences / customer_demand
    // are intentionally absent. The three bcase_* scalars carry the
    // values Executive Summary and Market used to derive from them.
    fetchAllStaticData(round, 'business-case').then(data => {
      this.setState({
        initialDemand:          data.initialDemand,
        salesClients:           data.salesClients,
        constants:              data.constants,
        primeRates:             data.primeRates,
        demandGrowthRate:       data.demandGrowthRate,
        features:               data.features,
        machines:               data.machines,
        debtClients:            data.debtClients,
        ratings:                data.ratings,
        comparableCompanies:    data.comparableCompanies,
        bcaseRevenueEstimate:   data.bcaseRevenueEstimate,
        bcasePriceFloor:        data.bcasePriceFloor,
        bcasePriceCeiling:      data.bcasePriceCeiling,
      });
    });
  };

  get extendedState() {
    return {
      ...this.state,
      activeRound: this.getRound(),
      goBack: this.goBack
    };
  }

  goBack = () => {
    goBack();
  };

  ifLoaded = (fields, Component) => {
    return some(
      fields.filter(i => i !== "roundInUrl"),
      field => isNil(this.extendedState[field])
    ) ? (
      <Loader type="ball-scale-ripple" active />
    ) : (
      <Component {...pick(this.extendedState, fields)} />
    );
  };

  render() {
    const { location, params } = this.props;
    const { pathname, search } = location;
    const active = isNil(params.part) ? "" : params.part;

    return (
      <div className="dashboard" style={dashboardStyle}>
        <BreadCrumbs
          crumbs={[
            { label: "Home", location: "/start" },
            { label: "Analysis", location: "/analysis" },
            { label: "Business Case" }
          ]}
        />
        <div style={columnsStyle}>
          <div className="team-reports-menu" style={menuStyle}>
            <Menu location={pathname} search={search} />
          </div>
          <Content active={active} ifLoaded={this.ifLoaded} />
        </div>
      </div>
    );
  }
}

export default BusinessCase;



// WEBPACK FOOTER //
// ./src/components/dashboard/BusinessCase.js